import { IconButton, Menu, MenuItem, ListItemIcon, ListItemText } from "@mui/material";
import { useState } from "react";
import MoreVertIcon from '@mui/icons-material/MoreVert';
import DownloadIcon from '@mui/icons-material/Download';
import EditIcon from '@mui/icons-material/Edit';
import { MedicalJournalShortDto, MedicalJournalStatus } from "../../models/medicalCheckups/medicalJournalShortDto";

interface JournalActionsMenuProps {
    journal: MedicalJournalShortDto;
    onDownload: (journalId: number) => void;
    onDownloadPdf: (journalId: number) => void;
    onSign: (journalId: number) => void;
    hasMultipleSelections: boolean;
}

export const JournalActionsMenu: React.FC<JournalActionsMenuProps> = ({
    journal,
    onDownload,
    onDownloadPdf,
    onSign,
    hasMultipleSelections
}) => {
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
    const open = Boolean(anchorEl);

    const handleClick = (event: React.MouseEvent<HTMLElement>) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const handleDownload = () => {
        onDownload(journal.id);
        handleClose();
    };

    const handleDownloadPdf = () => {
        onDownloadPdf(journal.id);
        handleClose();
    };

    const handleSign = () => {
        onSign(journal.id);
        handleClose();
    };

    const canDownloadExcel = !hasMultipleSelections; // Disable individual Excel download when multiple selections
    const canDownloadPdf = journal.status === MedicalJournalStatus.Signed; // PDF download only for signed journals
    const canSign = (journal.status === MedicalJournalStatus.Unsigned || journal.status === MedicalJournalStatus.SigningError) && !hasMultipleSelections; // Disable individual sign when multiple selections

    return (
        <>
            <IconButton
                onClick={handleClick}
                size="small"
                aria-controls={open ? 'journal-menu' : undefined}
                aria-haspopup="true"
                aria-expanded={open ? 'true' : undefined}
            >
                <MoreVertIcon />
            </IconButton>
            <Menu
                id="journal-menu"
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'right',
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'right',
                }}
                slotProps={{
                    paper: {
                        sx: {
                            borderRadius: 3,
                        },
                    },
                }}
            >
                <MenuItem 
                    onClick={handleSign} 
                    disabled={!canSign}
                >
                    <ListItemIcon>
                        <EditIcon fontSize="small" />
                    </ListItemIcon>
                    <ListItemText>Подписать</ListItemText>
                </MenuItem>
                <MenuItem 
                    onClick={handleDownloadPdf} 
                    disabled={!canDownloadPdf}
                >
                    <ListItemIcon>
                        <DownloadIcon fontSize="small" />
                    </ListItemIcon>
                    <ListItemText>Скачать (PDF)</ListItemText>
                </MenuItem>
                <MenuItem 
                    onClick={handleDownload} 
                    disabled={!canDownloadExcel}
                >
                    <ListItemIcon>
                        <DownloadIcon fontSize="small" />
                    </ListItemIcon>
                    <ListItemText>Скачать (XLSX)</ListItemText>
                </MenuItem>
            </Menu>
        </>
    );
};
